import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const AriesShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <path d="M41.1,5.7a8,8,0,0,0-8.8,1.6L24,15.2,15.7,7.3A8,8,0,0,0,6.9,5.7,7.9,7.9,0,0,0,2,13a8,8,0,0,0,8.1,8h.2a2,2,0,0,0,0-4h-.2A4,4,0,0,1,6,13,4,4,0,0,1,8.5,9.3a4.2,4.2,0,0,1,4.5.9l9,8.6V41a2,2,0,0,0,4,0V18.8l9-8.6a4.2,4.2,0,0,1,4.5-.9A4,4,0,0,1,42,13a4,4,0,0,1-4.1,4h-.2a2,2,0,0,0,0,4h.2A8,8,0,0,0,46,13,7.9,7.9,0,0,0,41.1,5.7Z" />
      </g>
    </g>
  </svg>
);

export default AriesShape;
